"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _underscore = require("underscore");
var _types = require("../../actions/types");
var _utils = require("../../utils");
var _constants = require("@studio/constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = exports.initialState = {
  isLoading: false,
  // Being used to block entry for director pro when source list hasn't been loaded yet
  loadStatus: _constants.PENDING,
  sources: [],
  defaultSelectedSource: '',
  isUpdating: false,
  isCreating: false,
  isUploading: false
};
function sources() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload,
    type = action.type;
  if ([_types.BROADCAST_CREATE_SOURCE, _types.BROADCAST_CREATE_CONTENT_SOURCE].includes(type)) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isCreating: true
    });
  }
  if (type === _types.BROADCAST_GET_SOURCES) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: state.sources.length === 0,
      loadStatus: _constants.PENDING
    });
  }
  if (type === "".concat(_types.BROADCAST_GET_SOURCES, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      loadStatus: _constants.FAILED
    });
  }
  if (type === _types.BROADCAST_UPLOAD_SOURCE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUploading: true
    });
  }
  if (["".concat(_types.BROADCAST_CREATE_SOURCE, "_FAILURE"), "".concat(_types.BROADCAST_CREATE_CONTENT_SOURCE, "_FAILURE")].includes(type)) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isCreating: false
    });
  }
  if (type === "".concat(_types.BROADCAST_UPLOAD_SOURCE, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUploading: false
    });
  }
  if (type === "".concat(_types.BROADCAST_GET_SOURCES, "_SUCCESS")) {
    var _sources = _toConsumableArray(payload.items);
    _sources = (0, _utils.findAndUpdateEmptySourceTitle)(_sources);
    var updatedSources = (0, _utils.retainPDFURLsInSources)(_sources, state.sources);
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: updatedSources,
      isLoading: false,
      loadStatus: _constants.DONE,
      isCreating: false
    });
  }
  if ([_types.BROADCAST_UPDATE_SOURCE, _types.BROADCAST_UPDATE_CONTENT_SOURCE].includes(type)) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: true
    });
  }
  if (["".concat(_types.BROADCAST_UPDATE_SOURCE, "_SUCCESS"), "".concat(_types.BROADCAST_UPDATE_SOURCE_THUMBNAIL, "_SUCCESS"), "".concat(_types.BROADCAST_UPDATE_CONTENT_SOURCE_STATUS, "_SUCCESS")].includes(type)) {
    /**
     * if source is a media type and the current updated source is visible i.e
     * hidden property is false then hide all other visible source that is of
     * type media i.e hidden should be set to true
     */
    var sourceWillBeVisible = payload.hidden === false;
    var _updatedSources = _toConsumableArray(state.sources);
    if ((0, _utils.isMediaSourceExcludeAudio)(payload) && sourceWillBeVisible) {
      _updatedSources = _updatedSources.map(function (s) {
        if ((0, _utils.isMediaSourceExcludeAudio)(s) && s._id !== payload._id) {
          return _objectSpread(_objectSpread({}, s), {}, {
            hidden: true
          });
        }
        return s;
      });
    }
    var _sources2 = _updatedSources.map(function (s) {
      if (s._id === payload._id) {
        return _objectSpread(_objectSpread({}, s), payload);
      }
      return s;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false,
      sources: _sources2
    });
  }
  if (["".concat(_types.BROADCAST_CREATE_SOURCE, "_SUCCESS"), "".concat(_types.BROADCAST_SAVE_RECORDING_AS_MEDIA_SOURCE, "_SUCCESS")].includes(type)) {
    /**
     * Create source api performs an upsert,
     * if the source is already present in state,
     * we don't want to update the state with a duplicate source
     */
    var sourceExists = state.sources.find(function (source) {
      return source._id === payload._id;
    });
    if (sourceExists) {
      // The 'presenterSessionId' is utilized when a presenter joins a Chime meeting SLI.
      // We need to maintain it in the source object locally
      return _objectSpread(_objectSpread({}, state), {}, {
        sources: state.sources.map(function (source) {
          return source.id === payload.id ? _objectSpread(_objectSpread({}, source), {}, {
            presenterSessionId: payload.presenterSessionId
          }) : source;
        })
      });
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: [].concat(_toConsumableArray(state.sources), [payload]),
      isCreating: false
    });
  }
  if (type === "".concat(_types.BROADCAST_UPLOAD_SOURCE, "_SUCCESS")) {
    var sourceIndex = state.sources.findIndex(function (source) {
      return source._id === payload._id;
    });
    if (sourceIndex !== -1) {
      var _updatedSources2 = _toConsumableArray(state.sources);
      _updatedSources2[sourceIndex] = payload;
      return _objectSpread(_objectSpread({}, state), {}, {
        sources: _updatedSources2,
        isUploading: false
      });
    } else {
      return _objectSpread(_objectSpread({}, state), {}, {
        sources: [].concat(_toConsumableArray(state.sources), [payload]),
        isUploading: false
      });
    }
  }
  if (["".concat(_types.BROADCAST_DELETE_SOURCES, "_SUCCESS"), "".concat(_types.BROADCAST_DELETE_SOURCE, "_SUCCESS")].includes(type)) {
    /**
     * This handles when one or multiple sources is to be deleted.
     * So its either an array of all the deleted sources when `BROADCAST_DELETE_SOURCES` action is dispatched
     * or the source deleted if `BROADCAST_DELETE_SOURCE` action was dispatched
     */
    var ids = (0, _underscore.isArray)(payload) ? payload : [payload._id];
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: _toConsumableArray(state.sources).filter(function (s) {
        return !ids.includes(s._id);
      })
    });
  }
  if (type === "".concat(_types.BROADCAST_REORDER_SOURCES, "_SUCCESS")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoading: false,
      sources: (0, _utils.findAndUpdateSource)(state.sources, payload)
    });
  }
  if (type === _types.BROADCAST_PROGRAM_SOURCES_SYNC) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false,
      sources: (0, _utils.sourcesWithPreviousDisconnectedState)(payload, state.sources)
    });
  }
  if (type === "".concat(_types.BROADCAST_UPDATE_SOURCE, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false
    });
  }
  if (type === _types.BROADCAST_DISCONNECT_SOURCE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (s) {
        if (s._id === payload.sourceId) {
          return _objectSpread(_objectSpread({}, s), {}, {
            disconnected: true
          });
        }
        return s;
      })
    });
  }
  if (type === _types.BROADCAST_CANCEL_SOURCE_DISCONNECT) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (s) {
        if (s._id === payload.sourceId) {
          return _objectSpread(_objectSpread({}, s), {}, {
            disconnected: false
          });
        }
        return s;
      })
    });
  }
  if (type === "".concat(_types.BROADCAST_CREATE_SOURCES, "_SUCCESS")) {
    //filter out the sources in payload if they are already present in the state
    var updatedPayload = payload.filter(function (source) {
      return !state.sources.find(function (s) {
        return s.value === source.value;
      });
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: [].concat(_toConsumableArray(state.sources), _toConsumableArray(updatedPayload)),
      isCreating: false
    });
  }
  if (type === _types.BROADCAST_INITIALIZING_SOURCE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (s) {
        if (s._id === payload.sourceId) {
          return _objectSpread(_objectSpread({}, s), {}, {
            isInitializing: payload.isInitializing
          }, payload.presenterSessionId !== undefined && {
            presenterSessionId: payload.presenterSessionId
          });
        }
        return s;
      })
    });
  }
  if (type === _types.BROADCAST_SOURCES_TRANSCODING_STATUS) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: payload
    });
  }
  if (type === "".concat(_types.BROADCAST_RESET_SOURCES, "_SUCCESS")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: payload ? (0, _utils.findAndUpdateSource)(state.sources, payload) : state.sources
    });
  }

  /*
  source.value should not be UNASSIGNED to avoid setting the name
  of all unassigned source to the same name in director PRO
  */
  if (type === _types.BROADCAST_SET_ATTENDEE_NAME) {
    var isValidAttendeeId = payload.attendeeId !== _constants.UNASSIGNED && payload.attendeeId !== '';
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (s) {
        if (isValidAttendeeId && s.value === payload.attendeeId) {
          return _objectSpread(_objectSpread({}, s), {}, {
            title: payload.name
          });
        }
        return s;
      })
    });
  }
  if (["".concat(_types.BROADCAST_CREATE_CONTENT_SOURCE_STATUS, "_SUCCESS"), "".concat(_types.BROADCAST_CREATE_CONTENT_SOURCE_STATUS, "_FAILURE"), "".concat(_types.BROADCAST_UPDATE_CONTENT_SOURCE_STATUS, "_FAILURE")].includes(type) && _constants.S3SourceTypes.includes(payload.type)) {
    var _updatedSources3 = _toConsumableArray(state.sources);
    var _sources3 = _updatedSources3.map(function (source) {
      if (source._id === payload._id) {
        return _objectSpread(_objectSpread({}, source), payload);
      }
      return source;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false,
      isCreating: false,
      sources: _sources3
    });
  }
  if (type === "".concat(_types.BROADCAST_UPDATE_CONTENT_SOURCE, "_FAILURE")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isUpdating: false
    });
  }
  if (["".concat(_types.BROADCAST_UPDATE_CONTENT_SOURCE, "_SUCCESS")].includes(type)) {
    /**
     * Create source api performs an upsert,
     * if the source is already present in state,
     * we don't want to update the state with a duplicate source
     */
    var _updatedSources4 = _toConsumableArray(state.sources);
    var _sources4 = _updatedSources4.map(function (source) {
      if (source._id === payload._id) {
        return _objectSpread(_objectSpread({}, source), payload);
      }
      return source;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: _sources4,
      isUpdating: _constants.S3SourceTypes.includes(payload.type)
    });
  }
  if (["".concat(_types.BROADCAST_CREATE_CONTENT_SOURCE, "_SUCCESS")].includes(type)) {
    /**
     * Create source api performs an upsert,
     * if the source is already present in state,
     * we don't want to update the state with a duplicate source
     */
    var _sourceExists = state.sources.find(function (source) {
      return source._id === payload._id;
    });
    if (_sourceExists) {
      return state;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: [].concat(_toConsumableArray(state.sources), [payload]),
      isCreating: _constants.S3SourceTypes.includes(payload.type)
    });
  }
  if (type === "".concat(_types.BROADCAST_GET_SOURCE, "_SUCCESS")) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sources: state.sources.map(function (source) {
        if (source._id === payload._id) {
          return payload;
        }
        return source;
      })
    });
  }
  return state;
}
var _default = exports["default"] = sources;